export const query = `query getProductItemsByProductIdWithHasDiscount($productId: String!) {
  catalog {
    product(productId: $productId) {
      productItems {
        id
        optionsSelections 
        price
        comparePrice
        formattedPrice
        hasDiscount
        formattedComparePrice
        availableForPreOrder
        isTrackingInventory
        inventory {
          status
          quantity
        }
        isVisible
        pricePerUnit
        formattedPricePerUnit
        preOrderInfo {
          limit
          message
        }
      }
    }
  }
}
`;
